import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Auto redirect if already logged in
  useEffect(() => {
    if (localStorage.getItem("isLoggedIn")) {
      navigate("/manager");
    }
  }, [navigate]);

  // HANDLE MOBILE INPUT
  const handleMobile = (e) => {
    const onlyNums = e.target.value.replace(/\D/g, "").slice(0, 10);
    setMobile(onlyNums);
  };

  // ================= SEND OTP =================
  const sendOtp = async (e) => {
    e.preventDefault();

    if (mobile.length !== 10) {
      toast.error("சரியான மொபைல் எண் உள்ளிடவும் ❌");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        "https://tvk-backend-yl1b.onrender.com/api/send-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mobile }),
        }
      );

      const data = await res.json();

      if (data.success) {
        toast.success("OTP அனுப்பப்பட்டது ✅");
        setStep(2);
      } else {
        toast.error("OTP அனுப்ப முடியவில்லை ❌");
      }

    } catch (err) {
      toast.error("Server error ❌");
    }

    setLoading(false);
  };

  // ================= VERIFY OTP =================
  const verifyOtp = async (e) => {
    e.preventDefault();

    if (otp.length !== 4) {
      toast.error("4 இலக்க OTP உள்ளிடவும் ❌");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        "https://tvk-backend-yl1b.onrender.com/api/verify-otp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mobile, otp }),
        }
      );

      const data = await res.json();

      if (data.success) {
        toast.success("வெற்றிகரமாக உள்நுழைந்தீர்கள் ✅");

        // ✅ SAVE LOGIN TO LOCAL STORAGE
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("mobile", mobile);

        // ✅ REDIRECT
        navigate("/manager");

      } else {
        toast.error("தவறான OTP ❌");
      }

    } catch (err) {
      toast.error("Server error ❌");
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <form
        className="login-form"
        onSubmit={step === 1 ? sendOtp : verifyOtp}
      >
        <h3 style={{ textAlign: "center", color: "#8B0000" }}>
          உறுப்பினர் உள்நுழைவு

        </h3>

        {/* STEP 1 - MOBILE */}
        {step === 1 && (
          <>
            <input
              type="tel"
              placeholder="மொபைல் எண்"
              value={mobile}
              onChange={handleMobile}
              required
            />

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "OTP அனுப்பவும்"}
            </button>
          </>
        )}

        {/* STEP 2 - OTP */}
        {step === 2 && (
          <>
            <input
              type="text"
              placeholder="4 இலக்க OTP"
              value={otp}
              onChange={(e) =>
                setOtp(e.target.value.replace(/\D/g, "").slice(0, 4))
              }
              required
            />

            <button type="submit" disabled={loading}>
              {loading ? "Verifying..." : "OTP சரிபார்க்க"}
            </button>
          </>
        )}
      </form>
    </div>
  );
}

export default Login;
